import { render } from "./dashboard_organizer_event_edit.vue?vue&type=template&id=450d7b32"
import script from "./dashboard_organizer_event_edit.vue?vue&type=script&lang=js"
export * from "./dashboard_organizer_event_edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__